import { createSelector, MemoizedSelector } from '@ngrx/store';
import { GlobalMessageEntities, GlobalMessageType } from '@boels/models';
import * as fromFeature from '../../reducers.index';
import { GlobalMessageState } from '../reducers/global-message.reducer';

export const getGlobalMessageState = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state.globalMessages,
);

export const getGlobalMessageEntities: MemoizedSelector<
  GlobalMessageState,
  GlobalMessageEntities
> = createSelector(
  getGlobalMessageState,
  (state: GlobalMessageState) => state.entities,
);

export const getGlobalMessageEntitiesByType = (
  type: GlobalMessageType,
): MemoizedSelector<GlobalMessageState, string[]> => {
  return createSelector(
    getGlobalMessageEntities,
    (entities) => entities && entities[type],
  );
};

export const getGlobalMessageCountByType = (
  type: GlobalMessageType,
): MemoizedSelector<GlobalMessageState, number> => {
  return createSelector(
    getGlobalMessageEntitiesByType(type),
    (entities) => entities && entities.length,
  );
};
